import { ArrowsRotateSpinIcon } from '@repo/icons';
import { TestId } from '@repo/test-id';

import PageFrame from '@shared/components/page/PageFrame';

interface Props {
  onGoBack: () => void;
}

export default function PaymentPendingContents({ onGoBack }: Props) {
  const testId = TestId.root('reservation.paymentPending');

  return (
    <PageFrame fullScreen testId={testId} onGoBack={onGoBack}>
      <div className="flex h-full w-full items-center justify-center p-4 text-center">
        <div className="inline-flex w-80 flex-col items-center justify-start gap-6">
          <ArrowsRotateSpinIcon />
          <div className="text-heading justify-start text-2xl leading-8 font-semibold">Przetwarzanie płatności</div>
          <div className="text-body justify-start text-base leading-6 font-normal">
            Trwa przetwarzanie Twojej płatności. To może potrwać chwilę…
          </div>
        </div>
      </div>
    </PageFrame>
  );
}
